export default "__VITE_ASSET__BVB7sShe__"